export default __webpack_public_path__ + "static/banner2-14d8cd01bd420f6cae61e2e41e0c42d4.jpg";